import React, { memo, useCallback, useState } from "react";

import { Button } from "components/ui/Button";
import { Dialog } from "components/ui/Dialog";
import { Select } from "components/ui/Select/Select";
import { useCancellationReasons } from "features/practice/hooks/useCancellationReasons";

const CancelAppointmentModalComponent = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
}) => {
  const [cancellationReason, setCancellationReason] = useState("");
  const { data: cancellationReasons, isLoading: isLoadingReasons } =
    useCancellationReasons();

  const hasReasons = cancellationReasons && cancellationReasons.length > 0;

  const reasonOptions = (cancellationReasons || []).map((reason) => ({
    label: reason,
    value: reason,
  }));

  const handleConfirm = useCallback(() => {
    if (hasReasons && !cancellationReason) return;

    onConfirm(cancellationReason || null);
    setCancellationReason("");
  }, [hasReasons, cancellationReason, onConfirm]);

  const handleClose = useCallback(() => {
    setCancellationReason("");
    onClose();
  }, [onClose]);

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      title="Cancel Appointment"
      width={500}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        <p
          style={{
            fontSize: "16px",
            color: "#26252c",
            margin: 0,
            fontWeight: 500,
          }}
        >
          Are you sure you want to cancel this appointment?
        </p>

        {!!hasReasons && (
          <div
            style={{ display: "flex", flexDirection: "column", gap: "6px" }}
          >
            <label style={{ fontSize: "14px", fontWeight: 500 }}>
              Cancellation Reason *
            </label>
            <Select
              name="cancellationReason"
              options={reasonOptions}
              value={cancellationReason}
              onChange={setCancellationReason}
              placeholder={isLoadingReasons ? "Loading…" : "Select reason"}
              disabled={isLoadingReasons}
              fullWidth
            />
          </div>
        )}

        <div
          style={{ display: "flex", justifyContent: "flex-end", gap: "12px" }}
        >
          <Button
            variant="outline"
            size="medium"
            onClick={handleClose}
            disabled={isLoading}
          >
            No, keep it
          </Button>
          <Button
            variant="primary"
            size="medium"
            onClick={handleConfirm}
            disabled={isLoading || (hasReasons && !cancellationReason)}
          >
            {isLoading ? "Cancelling..." : "Yes, cancel"}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export const CancelAppointmentModal = memo(CancelAppointmentModalComponent);
